var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C5.46957 3 4.96086 3.18964 4.58579 3.52721C4.21071 3.86477 4 4.32261 4 4.8V19.2C4 19.6774 4.21071 20.1352 4.58579 20.4728C4.96086 20.8104 5.46957 21 6 21H18C18.5304 21 19.0391 20.8104 19.4142 20.4728C19.7893 20.1352 20 19.6774 20 19.2V10.0452C19.9999 9.56785 19.7891 9.11009 19.414 8.7726L13.586 3.5274C13.211 3.18981 12.7024 3.0001 12.172 3H6ZM5.5 4.8C5.5 4.68065 5.55268 4.56619 5.64645 4.4818C5.74021 4.39741 5.86739 4.35 6 4.35H12V8.4C12 8.87739 12.2107 9.33523 12.5858 9.67279C12.9609 10.0104 13.4696 10.2 14 10.2H18.5V19.2C18.5 19.3193 18.4473 19.4338 18.3536 19.5182C18.2598 19.6026 18.1326 19.65 18 19.65H6C5.86739 19.65 5.74021 19.6026 5.64645 19.5182C5.55268 19.4338 5.5 19.3193 5.5 19.2V4.8ZM17.38 8.85H14C13.8674 8.85 13.7402 8.80259 13.6464 8.7182C13.5527 8.63381 13.5 8.51935 13.5 8.4V5.358L17.38 8.85Z",
    fill: "#3F3F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.f116acbc32b4e1ed1cba4ced467bf892.svg";
export { ForwardRef as ReactComponent };